// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success {
  color: #28ba62;
}

.reject {
  color: red;
}

.limit-confirmation-button {
  width: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/limits/limit-confirmation/limit-confirmation.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AACA;EACI,UAAA;AAEJ;;AAAA;EACI,YAAA;AAGJ","sourcesContent":[".success{\r\n    color: #28ba62;\r\n}\r\n.reject{\r\n    color: red;\r\n}\r\n.limit-confirmation-button{\r\n    width: 100px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
